import { formAPI } from 'api/form';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { locales } from 'utils/constants';
import { QUERY_KEY } from 'utils/enums';

export function useCreateForm() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: formAPI.create,
    onSuccess: (data) => {
      queryClient.setQueryData(QUERY_KEY.FIND_ONE_FORM, data);
      toast(locales.createSuccess, { type: 'success' });
    },
  });

  return mutation;
}
